import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { MainScene } from './scenes/MainScene';

interface PhaserImagePasteDemoProps {
}

interface PhaserImagePasteDemoState {
}

const gameConfig: GameConfig = {
    title: "Image Pasting Test",
    version: "0.0.2-demo",
    width: 800, 
    height: 600,
    backgroundColor: "#000000"
};

class PhaserImagePasteDemo extends React.Component<PhaserImagePasteDemoProps, PhaserImagePasteDemoState> {
    private game: Phaser.Game;
    constructor(props: PhaserImagePasteDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserImagePasteDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={MainScene} config={gameConfig} />
        </div>);
    }
}

export default PhaserImagePasteDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserImagePasteDemo/Main.tsx